import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import { Alert, Excel, TrayArrowUp } from '@opengov/react-capital-assets';
import isNil from 'lodash/isNil';
import React from 'react';
import locale from '../customReports-locale.json';
import { FontAccessibilityWarning } from '../FontAccessibilityWarning';
import { styles } from './SelectedFile.styles';

type Props = {
  fileName: string;
  errors?: string[];
  onReUpload: () => void;
};

export function SelectedFile({ fileName, onReUpload, errors }: Props) {
  const hasErrors = !isNil(errors) && errors.length > 0;

  return (
    <>
      <Typography sx={styles.title}>{locale.addNewExcelFileModal.selectedFile}</Typography>
      <Box
        sx={[
          styles.baseSelectedFileContainer,
          hasErrors ? styles.errorSelectedFileContainer : styles.defaultSelectedFileContainer
        ]}
      >
        <Box sx={styles.fileInfo}>
          <SvgIcon component={Excel} inheritViewBox sx={styles.excelIcon} />
          <Typography variant="body1" sx={styles.fileName}>
            {fileName}
          </Typography>
        </Box>

        <Button
          variant={hasErrors ? 'contained' : 'text'}
          startIcon={<TrayArrowUp />}
          onClick={onReUpload}
          sx={hasErrors ? styles.reUploadButtonErrorState : styles.reUploadButton}
          data-test="selected-file-reupload-button"
        >
          {locale.addNewExcelFileModal.reUpload}
        </Button>
      </Box>

      {hasErrors ? (
        errors.map((error, index) => (
          <Box key={index} sx={styles.errorMessageContainer} data-test="selected-file-error-message">
            <SvgIcon component={Alert} inheritViewBox sx={styles.errorIcon} />
            <Typography variant="body1" sx={styles.errorMessage}>
              {error}
            </Typography>
          </Box>
        ))
      ) : (
        <FontAccessibilityWarning />
      )}
    </>
  );
}
